import { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Button, Column, Form, Input, Link, Modal } from '../../..'
import { layerForm as layerFormProps } from '../../../../types'

const { FormGroup, FormHeader, Label } = Form

class LayerForm extends PureComponent {
    static propTypes = {
        assignToAllPlaylists: PropTypes.bool,
        errors: PropTypes.shape({
            entry_point: PropTypes.string,
            name: PropTypes.string,
            file: PropTypes.string,
            date_start: PropTypes.string,
            date_end: PropTypes.string,
        }),
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool,
        values: PropTypes.shape(layerFormProps),
        onChangeForm: PropTypes.shape({
            entry_point: PropTypes.func,
            name: PropTypes.func,
            file: PropTypes.func,
            date_start: PropTypes.func,
            date_end: PropTypes.func,
        }),
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        onClickNullStartDate: PropTypes.func.isRequired,
        onClickNullEndDate: PropTypes.func.isRequired,
        onClickRemoveStartDate: PropTypes.func.isRequired,
        onClickRemoveEndDate: PropTypes.func.isRequired,
        progress: PropTypes.number.isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        assignToAllPlaylists: false,
        errors: {
            name: null,
            file: null,
            date_start: null,
            date_end: null,
        },
        isOpen: false,
        isWorking: false,
        values: {},
        onChangeForm: {
            name: () => null,
            media: () => null,
            date_start: () => null,
            date_end: () => null,
        },
        onClickCancel: () => null,
        onClickSubmit: () => null,
    }

    get progress() {
        const { progress } = this.props
        return Math.round(progress * 100)
    }

    renderStartDateLabel() {
        const { onClickRemoveStartDate, t } = this.props

        return (
            <Fragment>
                {t('date-start')}
                &nbsp;
                <Link onClick={onClickRemoveStartDate}>&times;</Link>
            </Fragment>
        )
    }

    renderEndDateLabel() {
        const { onClickRemoveEndDate, t } = this.props

        return (
            <Fragment>
                {t('date-end')}
                &nbsp;
                <Link onClick={onClickRemoveEndDate}>&times;</Link>
            </Fragment>
        )
    }

    render() {
        const {
            assignToAllPlaylists,
            errors,
            isOpen,
            isWorking,
            onChangeForm,
            onClickCancel,
            onClickSubmit,
            onClickNullStartDate,
            onClickNullEndDate,
            values,
            t,
        } = this.props
        const {
            entry_point: errorEntryPoint,
            name: errorName,
            file: errorFile,
            date_start: errorDateStart,
            date_end: errorDateEnd,
        } = errors
        const {
            entry_point,
            file,
            name,
            date_start,
            date_end,
        } = values
        const {
            all_playlists: onChangeAllPlaylists,
            entry_point: onChangeEntryPoint,
            file: onChangeFile,
            name: onChangeName,
            date_start: onChangeDateStart,
            date_end: onChangeDateEnd,
        } = onChangeForm

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel}>
                <Form>
                    <FormHeader>{t('Layer upload')}</FormHeader>
                    <FormGroup title={t('Layer')}>
                        <Label id="name" label={t('Layer Name')} error={errorName}>
                            <Input id="name" name="name" type="text" error={!!errorName} onChange={onChangeName} size="md" value={name} />
                        </Label>
                        <Label id="entry_point" label={t('Entry Point')} error={errorEntryPoint}>
                            <Input
                                id="entry_point"
                                name="entry_point"
                                type="text"
                                error={!!errorEntryPoint}
                                onChange={onChangeEntryPoint}
                                size="md"
                                value={entry_point}
                            />
                        </Label>
                        <Label id="file" label={t('Layer')} error={errorFile}>
                            <Input id="file" name="file" type="file" error={!!errorFile} onChange={onChangeFile} value={file} accept=".tar,.tgz,.zip" />
                        </Label>
                        <div>
                            <Label
                                id="all_playlists"
                                label={t('layer-upload-all-playlists')}
                            >
                                <Input
                                    id="all_playlists"
                                    name="all_playlists"
                                    type="check"
                                    onChange={() => onChangeAllPlaylists(!assignToAllPlaylists)}
                                    value={assignToAllPlaylists}
                                />
                            </Label>
                        </div>
                    </FormGroup>
                    <FormGroup title={t('schedule')}>
                        {date_start && (
                            <Label id="date_start" label={t('date-start')} error={errorDateStart}>
                                <Input
                                    id="date_start"
                                    name="date_start"
                                    type="date"
                                    error={!!errorDateStart}
                                    onChange={onChangeDateStart}
                                    value={date_start}
                                    withTime
                                />
                            </Label>
                        )}
                        {!date_start && (
                            <div>
                                <Link onClick={onClickNullStartDate}>{t('date-start-add')}</Link>
                            </div>
                        )}
                        {date_end && (
                            <Label id="date_end" label={t('date-end')} error={errorDateEnd}>
                                <Input id="date_end" name="date_end" type="date" error={!!errorDateEnd} onChange={onChangeDateEnd} value={date_end} withTime />
                            </Label>
                        )}
                        {!date_end && (
                            <div>
                                <Link onClick={onClickNullEndDate}>{t('date-end-add')}</Link>
                            </div>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Column right width="100%">
                            {!!isWorking && (
                                <Button theme="light" onClick={onClickCancel} size="sm">
                                    {t('Cancel')}
                                </Button>
                            )}
                            <Button onClick={onClickSubmit} size="sm" theme={isWorking ? 'loading' : 'primary'} disabled={isWorking}>
                                {isWorking ? `${this.progress} %` : t('Upload')}
                            </Button>
                        </Column>
                    </FormGroup>
                </Form>
            </Modal>
        )
    }
}

export default LayerForm
